



import { useContext, useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../context/Context";
import toast from "react-hot-toast";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, fireDB } from "../../firebase/FirebaseConfig";
import Loader from '../../components/Loader/Loader'
import { collection, onSnapshot, query, where } from "firebase/firestore";
import './Login.css';

function Login() {

  const context = useContext(MyContext);
    const { loading, setLoading } = context;

    // navigate 
    const navigate = useNavigate();

    // User Signup State 
    const [userLogin, setUserLogin] = useState({
        email: "",
        password: ""
    });


        const userLoginFunction = async (e) => {
          e.preventDefault();
          // validation 
          if (userLogin.email === "" || userLogin.password === "") {
              toast.error("All Fields are required")
          } else if(userLogin.password.length<6){
            toast.error("check email or password or register")
          }
  
          setLoading(true);
          try {
              const users = await signInWithEmailAndPassword(auth, userLogin.email, userLogin.password);
              // console.log(users.user)
  
              try {
                  const q = query(
                      collection(fireDB, "user"),
                      where('uid', '==', users?.user?.uid)
                  );
                  const data = onSnapshot(q, (QuerySnapshot) => {
                      let user;
                      QuerySnapshot.forEach((doc) => user = doc.data());

                      localStorage.setItem("users", JSON.stringify(user) )
                    //   setUserLogin({
                    //       email: "",
                    //       password: ""
                    //   })
                      toast.success("Login Successfully");
                      setLoading(false);

                      if(user.role === "user") {
                          navigate('/userDashboard');
                      }else if(user.role === "seller") {
                        navigate('/sellerDashboard');
                      }
                      else {
                          navigate('/adminDashboard');
                          
                      }
                  });

                  return () => data;
              } catch (error) {
                  console.log(error);
                  setLoading(false);
              }
          } catch (error) {
              console.log(error);
              setLoading(false);
              toast.error("Login Failed");
          }
        }
  
        useEffect(() => {
          // Scroll to the top when the component loads
          window.scrollTo(0, 0);
         
      }, []);
        
  return (
    <div>

<div className="h-screen  flex items-center justify-center ">
{loading && <Loader />}
  <div className="relative  bottom-16">
  
    <div id="form-container" className="bg-green-500 p-10  rounded-lg shadow-2xl w-full md:w-[350px] relative z-10 transform transition duration-500 ease-in-out">
      <h2 id="form-title" className="text-center text-3xl font-bold mb-10 ">Login</h2>
      <form className="space-y-5 form">
     
        <input className="w-full input h-10 border border-gray-800 px-3 rounded-lg" placeholder="Email" id="" name="" type="text"   value={userLogin.email}
                        onChange={(e) => {
                            setUserLogin({
                                ...userLogin,
                                email: e.target.value
                            })
                        }} />
        <input className="w-full input h-10 border border-gray-800 px-3 rounded-lg" placeholder="Password" id="" name="" type="password"  value={userLogin.password}
                        onChange={(e) => {
                            setUserLogin({
                                ...userLogin,
                                password: e.target.value
                            })
                        }} />
                        
                        <div className="flex justify-center">         
        <button className="w-44 h-10 mt-2 border border-gray-800 bg-[#24da67] text-white font-semibold py-2 px-4 font-poppins rounded-xl focus:outline-none focus:shadow-outline"    onClick={userLoginFunction}>Sign in</button>
        </div>
        <Link to={"/signup"} className="flex justify-center text-black text-sm font-medium mt-2 pt-2" >Don't have an account / Signup</Link>
      
      </form>

    </div>
  </div>

</div>


    </div>
  )
}

export default Login